<template>
  <div v-if="markers.length" class="bottomRouge">
    <gmap-map
      class="gmap"
      :center="{
        lat: markers[0].latitude,
        lng: markers[0].longitude,
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapPanneauxNumerique"
      @tilesloaded="levelZoom">
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude,
        }"
        @click="afficheFace(m)"
        :icon="m.icon">
      </gmap-marker>
      <gmap-marker
        v-if="markerVenteNumerique.lat"
        :position="{
          lat: markerVenteNumerique.lat,
          lng: markerVenteNumerique.lng,
        }"
        :icon="markerVenteNumerique.icon">
      </gmap-marker>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-opportunites :bg="bg" :detailFaceNumerique="detailFaceNumerique" v-if="show"/>
    </transition>
  </div>
</template>

<script>
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'cartePanneauxNumerique',
  props: ['markers', 'markerVenteNumerique'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      moyLat: 0,
      moyLng: 0,
      centreCarte: {},
      detailFaceNumerique: {},
      show: false,
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    afficheFace(m) {
      this.detailFaceNumerique = m;
      this.show = true;
    },
    async levelZoom() {
      if (this.markers.length && !this.isLoadOnce) {
        const bounds = new google.maps.LatLngBounds();
        filterLatLng(this.markers);
        this.markers.forEach(m => {
          if (m.latitude !== 0 && m.longitude !== 0
          && m.latitude !== null && m.longitude !== null) {
            bounds.extend({ lat: m.latitude, lng: m.longitude });
          }
        });
        if (this.markerVenteNumerique !== undefined &&
        this.markerVenteNumerique.lat !== undefined) {
          bounds.extend({ lat: this.markerVenteNumerique.lat, lng: this.markerVenteNumerique.lng });
        }
        this.$refs.mapPanneauxNumerique.fitBounds(bounds);
        this.isLoadOnce = true;
      }
    },
  },
  async mounted() {
    const map = await this.$refs.mapPanneauxNumerique.$mapPromise;
    const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
      name: MAP_TYPE_NAME,
    });
    map.mapTypes.set('styled_map', styleMap);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxNumeriques/cartePanneauxNumerique.vue